import React, { useState, useEffect } from "react";
import { Button, Container, Grid, useTheme } from "@mui/material";

const PromotionMenu = ({
  priceTable,
  selectedStartTime,
  handleSelectPriceTableIndex,
  isTimeReserved,
}) => {
  const [selectedPromotionIndex, setSelectedPromotionIndex] = useState(-1);
  const theme = useTheme();

  useEffect(() => {
    setSelectedPromotionIndex(-1);
    handleSelectPriceTableIndex(-1);
  }, [selectedStartTime]);

  const addHours = (date, hours) => {
    const newDate = new Date(date);
    const floorHours = Math.floor(hours);
    const minutes = (hours - floorHours) * 60;
    newDate.setHours(newDate.getHours() + floorHours);
    newDate.setMinutes(newDate.getMinutes() + minutes);
    return newDate;
  };

  const handleSelectPromotion = (index) => {
    handleSelectPriceTableIndex(index);
    setSelectedPromotionIndex(index);
  };

  return (

    <Grid container spacing={1} >
      {selectedStartTime == null
        ? null
        : priceTable?.Hour.map((hourItem, index) => {
            const Hour = priceTable.Hour[index];
            const FreeHour = priceTable.FreeHour[index];
            const totalHour = addHours(
              new Date(selectedStartTime),
              Hour + FreeHour
            );

            const isDisabled = isTimeReserved(totalHour, "promo");

            const buttonText = `${Hour + FreeHour}小時${
              FreeHour !== 0 ? `(含贈${FreeHour})` : ""
            } `;
            const displayText = isDisabled
              ? `${buttonText}(已預定)`
              : buttonText;

            const isSelected = selectedPromotionIndex === index;

            return (
              <Grid item xs={6} key={index}>
                <Button
                  fullWidth
                  disabled={isDisabled}
                  onClick={() => handleSelectPromotion(index)}
                  sx={
                    isSelected
                      ? {
                          fontSize: "12pt",
                          border: 2,
                          borderRadius: 1,
                          borderColor: theme.palette.selected,
                          color: theme.palette.selected,
                          fontWeight: "bold",
                        }
                      : {
                          borderColor: theme.palette.primary.main,
                          color: theme.palette.primary.main,
                          border: 1,
                          borderRadius: 1,
                          fontSize: "12pt",
                        }
                  }
                >
                  {displayText}
                </Button>
              </Grid>
            );
          })}
    </Grid>
  );
};

export default PromotionMenu;
